
import { FirearmAssignmentEntityDecorator } from './firearm-assignment.decorator';
import { FirearmAssignment } from './firearm-assignment.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmAssignmentTypeInfoBase implements CrudTypeInfo<FirearmAssignment, number> {
  name = 'Firearm Assignment';
  entityDecorator = new FirearmAssignmentEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_ASSIGNMENT'];
  editAuthorities = ['WRITE_FIREARM_ASSIGNMENT'];
  deleteAuthorities = ['WRITE_FIREARM_ASSIGNMENT'];
  viewAuthorities = ['READ_FIREARM_ASSIGNMENT'];
  
  searchRouteBase = ['/firearmassignment/search'];
  createRouteBase = ['/firearmassignment/create'];
  editRouteBase = ['/firearmassignment/edit'];
  viewRouteBase = ['/firearmassignment/view'];
  
  description(item: FirearmAssignment): string {
    return '' +  item.firearmAssignmentId;
  }
}



